/** Petites pièces partagées du Grand Quiz du Lair : logo d'épreuve, sons, accès serveur. */
import React from 'react';
import { SERVER } from './quizShowFormats';
import { Emblem } from './QuizShowLogos';

export function FormatLogo({ f, small, still }) {
  return <div className={`qs-logo${small ? ' is-small' : ''}`} style={{ '--c1': f.c1, '--c2': f.c2 }}><Emblem f={f} still={still} /></div>;
}

// Sons synthétisés (aucun fichier à charger)
let ctx = null;
const tone = (freq, at, dur, type = 'sine', gain = 0.12, slide = 0) => {
  const o = ctx.createOscillator(); const g = ctx.createGain();
  o.type = type; o.frequency.setValueAtTime(freq, ctx.currentTime + at);
  if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(30, freq + slide), ctx.currentTime + at + dur);
  g.gain.setValueAtTime(0.0001, ctx.currentTime + at);
  g.gain.exponentialRampToValueAtTime(gain, ctx.currentTime + at + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + at + dur);
  o.connect(g).connect(ctx.destination); o.start(ctx.currentTime + at); o.stop(ctx.currentTime + at + dur + 0.05);
};
const SOUNDS = {
  good: () => { tone(660, 0, 0.12, 'triangle'); tone(990, 0.09, 0.2, 'triangle'); },
  bad: () => { tone(220, 0, 0.32, 'sawtooth', 0.08, -90); },
  flip: () => tone(520, 0, 0.06, 'square', 0.04),
  tick: () => tone(1200, 0, 0.05, 'square', 0.04),
  buzz: () => { tone(140, 0, 0.6, 'sawtooth', 0.1); tone(146, 0, 0.6, 'sawtooth', 0.08); },
  start: () => { [523, 659, 784].forEach((f, k) => tone(f, k * 0.08, 0.18, 'triangle')); },
  win: () => { [523, 659, 784, 1046].forEach((f, k) => tone(f, k * 0.09, 0.26, 'triangle', 0.13)); },
  cash: () => { tone(1318, 0, 0.08, 'square', 0.05); tone(1760, 0.07, 0.25, 'square', 0.05); },
  trap: () => { tone(300, 0, 0.5, 'sawtooth', 0.1, -240); tone(90, 0.05, 0.5, 'square', 0.06); },
  dig: () => { tone(180, 0, 0.08, 'square', 0.07, -80); tone(90, 0.02, 0.12, 'triangle', 0.1); },
  fire: () => { tone(440, 0, 0.1, 'triangle'); tone(880, 0.06, 0.28, 'triangle', 0.1, 220); },
  blip: () => tone(880 + Math.random() * 240, 0, 0.03, 'square', 0.018),
  roll: () => tone(700 + Math.random() * 300, 0, 0.05, 'square', 0.035),
  joker: () => { [392, 523, 784, 1046].forEach((f, k) => tone(f, k * 0.06, 0.22, 'sawtooth', 0.06)); },
  fanfare: () => { [523, 523, 523, 659, 784, 659, 784, 1046].forEach((f, k) => tone(f, k * 0.12, 0.2, 'triangle', 0.13)); }
};
export function sfx(name) {
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    if (SOUNDS[name]) SOUNDS[name]();
  } catch (e) { /* pas de son, tant pis */ }
}

export function makeApi(key) {
  const call = async (method, path, body) => {
    const r = await fetch(`${SERVER}/api/quizshow${path}`, { method, headers: { 'x-qs-key': key, ...(body ? { 'Content-Type': 'application/json' } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.error || `Erreur ${r.status}`);
    return j;
  };
  return {
    get: (p) => call('GET', p), post: (p, b) => call('POST', p, b || {}), put: (p, b) => call('PUT', p, b || {}), del: (p) => call('DELETE', p),
    upload: async (file) => {
      const fd = new FormData(); fd.append('file', file);
      const r = await fetch(`${SERVER}/api/quizshow/media`, { method: 'POST', headers: { 'x-qs-key': key }, body: fd });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Envoi impossible');
      return j;
    }
  };
}
